import React from "react";
import cup from "../../../../../../assets/images/cup 2.png";
import EnterImage from "../../../../../../assets/images/unsplash_hUHzaiAHuUc.png";
import AuditionCardReuse from "../../../../../AuditionAdmin/AuditionCardReuse";
import AllDataHeader from "../../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../../Reuseable/LoaderPost";
import EventsNav from "./Content/Event/EventsNav";
function DashboardAudition() {
  return (
    <>
      <EventsNav />

      <AllDataHeader title="live auditions " image={cup} count={"Zero"} />

      {/* {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionCardReuse
          data={events}
          urlLinkInstruction={``}
          urlLinkFeedback={``}
        />
      )} */}


            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-3 mb-3 mb-2">
                <div className="card card-bg ">
                  <img
                    src={EnterImage}
                    className="img-fluid card-img"
                    alt=""
                  />
                  <div className="p-3">
                    <center>
                      <h5 className="text-white text-center title-limit">
                        Guitar Competition
                      </h5>
                      <p className="text-secondary">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been.{" "}
                      </p>
                      <button className="btn BlueBtn w-100">Done</button>
                    </center>
                  </div>
                </div>
              </div>
            </div>
    </>
  );
}

export default DashboardAudition;
